import React from 'react'
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import './FaultFirstPageCustom_Coral.css';
import Chart from 'chart.js/auto';
import { Line } from "react-chartjs-2";
import * as $ from 'jquery';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import moment from 'moment';
import WaterMark from '../../DashboardMain_Coral/WaterMark';
import NoData_Coral from '../../Driveanalysis_Coral/NoData_Coral';
import ChartLoader_Coral from '../../Driveanalysis_Coral/ChartLoader_Coral';
import 'chartjs-plugin-datalabels';

let arraydataday = []
let arraydatadayvehical = []
export default function FaultFirstPageCharts_Coral(props) {
    let { title, template_id, show, soarting, gloablfilter, IND } = props;
    const [startDate, setStartDate] = useState(props.gloablfilter.startDate);
    const [endDate, setEndDate] = useState(props.gloablfilter.endDate);
    let temp = [];
    const vin_num = "MAT486022NZF15168";
    const [topping, setTopping] = useState("Fault")
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [falutTriggerParams, setFaultTriggerParams] = useState([]);
    const [dataVehicale, setDataVehicale] = useState([]);
    const [dataVehicaleday, setDataVehicaleday] = useState([]);
    const [dataVehicaledaynew, setDataVehicaledayNew] = useState([]);

    const [faultSelected, setFaultSelected] = useState('day')
    const [falutTrigger, setFaultTrigger] = useState({
        labels: [],
        datasets: [],
        options: {
            plugins: {
                datalabels: {
                  display: false,
                },
                legend: {
                  display: false // Hide the legend
                },
                tooltip: {
                  enabled: true // Disable tooltip
                }
              },
            scales: {
                y: {
                    grid: {
                        display: false
                    }
                },
                x: {
                    grid: {
                        display: false
                    }
                }
            },
            maintainAspectRatio: false,
        }
    });
    const [LineContainerBody, setCssLineCont] = useState({ height: "360px", });
console.log('charts');
    const onRadioChange = e => {
        setTopping(e.target.value)
        const topping1 = e.target.value
        if (topping1 === "Fault" && faultSelected === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehiclemonthwisefault', body: { filterdata: gloablfilter, IND } }, responceData);
        }

        if (topping1 === "Fault" && faultSelected === "day") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataDate);
        }

        if (topping1 === "Alarm" && faultSelected === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehiclemonthwisefault', body: { filterdata: gloablfilter, IND } }, responceDataVehicale);
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicletotal', body: { filterdata: gloablfilter, IND } }, responceDataTotalVehicale);
        }

        if (topping1 === "Alarm" && faultSelected === "day") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataVehicaleday);
        }
    }

    function datesArray(start, end) {
        let result = [], current = new Date(start);
        while (current <= end)
            result.push(current) && (current = new Date(current)) && current.setDate(current.getDate() + 1);
        for (let i = 0; i < result.length; i++) {
            temp.push(
                result[i].toISOString().slice(0, 10)
            );
        }
        return temp;
    }

    const getMonths = (fromDate, toDate) => {
        const fromYear = fromDate.getFullYear();
        let fromMonth = fromDate.getMonth();
        const toYear = toDate.getFullYear();
        let toMonth = toDate.getMonth();
        const months = [];

        for (let year = fromYear; year <= toYear; year++) {
            let monthNum = year === fromYear ? fromMonth : 0;
            const monthLimit = year === toYear ? toMonth : 11;

            for (; monthNum <= monthLimit; monthNum++) {
                let month = monthNum + 1;
                month = month < 10 ? '0' + month : '' + month
                year = year.toString()
                let yeamon = year.concat(month);
                months.push(yeamon);
            }
        }
        return months;
    }

    function getMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString('en-US', { month: 'short' });
    }

    const responceData = (dataRes, LableName) => {
        let lableName = LableName
        let defaultArr = [];
        let defaultArr1 = [];
        defaultArr1 = dataRes;
        let colorArr = ["#3588a6", "#4c95b0", "#62a3ba", "#79b0c4", "#8fbdce"]
        if (lableName == undefined)
            lableName = "Faultly vehicle count"
        if (lableName === "Faultly vehicle count")
            defaultArr.push({ label: "Count", data: [], fill: false, borderColor: colorArr[0] })
        else
            defaultArr.push({ label: "% Count", data: [], fill: false, borderColor: colorArr[0] })
        let st = moment(new Date(props.gloablfilter.startDate)).format("YYYY-MM-DD");
        let ed = moment(new Date(props.gloablfilter.endDate)).format("YYYY-MM-DD")
        const dateArr = getMonths(new Date(st), new Date(ed));
        for (let q = 0; q < dateArr.length; q++) {
            dataRes.forEach((obj1) => {
                if (dateArr[q] === obj1.key.monthId) {
                    for (let t = 0; t < defaultArr.length; t++) {
                        defaultArr[t].data.push(obj1.faulty_vehicle.value)
                    }
                }
            })

            let count = 0;
            for (let pt = 0; pt < defaultArr.length; pt++) {
                if (defaultArr[pt].data.length > count) {
                    count = defaultArr[pt].data.length;
                }
            }

            for (let xt = 0; xt < defaultArr.length; xt++) {
                if (defaultArr[xt].data.length !== count) {
                    defaultArr[xt].data.push(0)
                }
            }
        }

        var bags = [];
        let monthArray = [];
        dataRes.map(({ key, i }) => {
            let year = key.monthId.substring(0, 4)
            let month = key.monthId.substring(4)
            let monthYear = getMonthName(month) + "-" + year
            monthArray.indexOf(monthYear) === -1 && monthArray.push(monthYear)
        })

        const data = {
            labels: monthArray,
            datasets: defaultArr,
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                    datalabels: {
                        display: false,
                      },
                },
                scales: {
                    y: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: lableName,
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "Month"
                        }
                    }
                },
                maintainAspectRatio: false,
            }
        };

        if (data.labels.length > 7) {
            const newWidth = 500 + ((data.labels.length - 7) * 10)
            setCssLineCont({
                width: newWidth + 'px',
                height: "360px",
            })
        }
        setFaultTrigger(data)
    }

    function responceDataVehicale(data) {
        let arraydata = []
        data.forEach((obj1) => {
            arraydata.push({ monthId: obj1.key.monthId, faulty_vehicle: obj1.faulty_vehicle.value })
        })
        setDataVehicale(arraydata)
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicletotal', body: { filterdata: gloablfilter, IND } }, responceDataTotalVehicale);
    }, [dataVehicale])

    function responceDataTotalVehicale(data) {
        let arraydata = []
        let percentarray = []
        let percent = 0;
        const lableName = "Percentage of faultly vehicle"
        data.forEach((obj1) => {
            arraydata.push({ monthId: obj1.key.monthId, total_vehicle: obj1.total_vehicle.value })
        })
        arraydata.forEach((obj1, i) => {
            percent = 0;
            if (obj1.monthId === dataVehicale[i].monthId) {
                percent = (dataVehicale[i].faulty_vehicle / obj1.total_vehicle) * 100
                percentarray.push({ monthId: obj1.monthId, faulty_vehicle: percent })
            }
        })

        let perarray = []
        percentarray.forEach((obj1, i) => {
            perarray.push({ key: { monthId: obj1.monthId }, faulty_vehicle: { value: obj1.faulty_vehicle } })
        })
        responceData(perarray, lableName)
    }

    function responceDataVehicaleday(data) {
        let arraydata = []
        data.forEach((obj1) => {
            arraydata.push({ eventdate: obj1.key.eventdate, Faulty_vehicle: obj1.Faulty_vehicle.value })
        })
        setDataVehicaleday(arraydata)
    }

   
    function responceDataVehicaleday(data) {
        let arraydata = []
        data.forEach((obj1) => {
            arraydata.push({ eventdate: obj1.key.eventdate, Faulty_vehicle: obj1.Faulty_vehicle.value })
        })
        setDataVehicaleday(arraydata)
    }

    function responceDataTotalVehicaleday(data) {
       
        let arraydata = []
        let percentarray = []
        let percent = 0

        data.forEach((obj1) => {
            arraydata.push({ eventdate: obj1.key.eventdate, total_vehicle: obj1.total_vehicle.value })
            
        })
        arraydata.forEach((obj1, i) => {
            if (obj1.eventdate === dataVehicaleday[i].eventdate) {
                percent = (dataVehicaleday[i].Faulty_vehicle / obj1.total_vehicle) * 100
                percentarray.push({ eventdate: obj1.eventdate, Faulty_vehicle: percent })
            }
        })


        let perarray = []
        percentarray.forEach((obj1, i) => {
            perarray.push({ key: { eventdate: obj1.eventdate }, Faulty_vehicle: { value: obj1.Faulty_vehicle } })
        })
        responceDataDate(perarray, "Percentage of faulty vehicle")
        console.log(perarray)
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataDate);
    }, [gloablfilter])

    useEffect(() => {
        $("canvas").css('display', '');
        if (topping === "Fault" && faultSelected === "day") {

        }
        if (topping === "Alarm" && faultSelected === "month") {

        }
        if (topping === "Alarm" && faultSelected === "day") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataVehicaleday);
        }
    }, [gloablfilter]);

    function responceDataDate(dataDate, LableName) {
        if (dataDate.length > 0) {
            let lableName = LableName
            let defaultArr = [];
            let defaultArr1 = dataDate;
            let colorArr = ["#3588a6", "#4c95b0", "#62a3ba", "#79b0c4", "#8fbdce"]
            if (lableName == undefined)
                lableName = "Faultly vehicle count"
            if (lableName === "Faultly vehicle count")
                defaultArr.push({ label: "Count", data: [], fill: false, borderColor: colorArr[0] })
            else
                defaultArr.push({ label: "% Count", data: [], fill: false, borderColor: colorArr[0] })

            const dateArr = datesArray(new Date(props.gloablfilter.startDate), new Date(props.gloablfilter.endDate));
            for (let q = 0; q < dateArr.length; q++) {
                dataDate.forEach((obj1) => {
                    if (dateArr[q] === obj1.key.eventdate) {
                        for (let t = 0; t < defaultArr.length; t++) {
                            defaultArr[t].data.push(obj1.Faulty_vehicle.value)
                        }
                    }
                })

                let count = 0;
                for (let pt = 0; pt < defaultArr.length; pt++) {
                    if (defaultArr[pt].data.length > count) {
                        count = defaultArr[pt].data.length;
                    }
                }

                for (let xt = 0; xt < defaultArr.length; xt++) {
                    if (defaultArr[xt].data.length !== count) {
                        defaultArr[xt].data.push(0)
                    }
                }
            }

            let monthArrayD = [];
            dataDate.map(({ key, i }) => {
                monthArrayD.indexOf(key.eventdate) === -1 && monthArrayD.push(key.eventdate)
            })

            const data = {
                labels: monthArrayD,
                datasets: defaultArr,
                options: {
                    plugins: {
                        legend: {
                            display: false
                        },
                        datalabels: {
                            display: false,
                          },
                    },
                    scales: {
                        y: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: lableName
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Day"
                            }
                        }
                    },
                    maintainAspectRatio: false,
                }
            };

            if (data.labels.length > 7) {
                const newWidth = 500 + ((data.labels.length - 7) * 10)
                setCssLineCont({
                    width: newWidth + 'px',
                    height: "360px",
                })
            }
            setFaultTrigger(data)
        } else {
            setFaultTrigger({
                labels: [],
                datasets: [],
                options: {
                    plugins: {
                        datalabels: {
                          display: false,
                        },
                        legend: {
                          display: false // Hide the legend
                        },
                        tooltip: {
                          enabled: true // Disable tooltip
                        }
                      },
                    scales: {
                        y: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Fault count"
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Month"
                            }
                        }
                    },
                    maintainAspectRatio: false,
                }
            });
        }
    }

    const changeFaultTrigger = (selectOp) => {
        setFaultSelected(selectOp);
        const faultSelected1 = selectOp
        if (topping === "Fault" && faultSelected1 === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehiclemonthwisefault', body: { filterdata: gloablfilter, IND } }, responceData);
        }
        if (topping === "Fault" && faultSelected1 === "day") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataDate);
        }
        if (topping === "Alarm" && faultSelected1 === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehiclemonthwisefault', body: { filterdata: gloablfilter, IND } }, responceDataVehicale);
        }
        if (topping === "Alarm" && faultSelected1 === "day") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultyvehicledaywise', body: { filterdata: gloablfilter, IND } }, responceDataVehicaleday);
        }
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/percentagefaultyvehicaldaywise', body: { filterdata: gloablfilter, IND } }, responceDataTotalVehicaleday);
    }, [dataVehicaleday])

    return (
        <div className="col-md-12 col-lg-6 col-sm-12 pr-0">
            <div className="v-title chartbox3">
                <div className="row mb-3">
                    <div className="col-md-12 col-sm-6 col-lg-8">
                        <div className="titlebg">Percentage of faulty vehicle</div>
                    </div>
                    <div className="col-md-12 col-sm-6 col-lg-4">
                        <select className="form-select form-select-sm" aria-label="Default select example" onChange={(event) => changeFaultTrigger(event.target.value)}
                            value={faultSelected}>
                            <option value="month">Month</option>
                            <option value="day">Day</option>
                        </select>
                    </div>
                </div>
                <div className="chartHGT">
                    <div className="mb-4">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="FaultyVehicleCount" id="FaultyVehicleCount" value="Fault" checked={topping === "Fault"} onClick={onRadioChange} />
                            <label className="form-check-label" htmlFor="FaultyVehicleCount">Faulty vehicle count</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="FaultyVehicleCount" id="PercentageOfFaultyVehicle" value="Alarm" checked={topping === "Alarm"} onClick={onRadioChange} />
                            <label className="form-check-label" htmlFor="PercentageOfFaultyVehicle">Percentage of faulty vehicle</label>
                        </div>
                    </div>
                    <div className="chartHGT aa">
                        <WaterMark />
                        <div style={{ width: 'auto', maxWidth: 'auto', }}>
                            <div className='LineContainerBody' style={{ height: "324px" }}>
                                {/* style={LineContainerBody} */}
                                {(isLoading) ? <ChartLoader_Coral /> :
                                    (falutTrigger.datasets.length > 0 ?
                                        <Line data={falutTrigger} options={falutTrigger.options} /> :
                                        <NoData_Coral />)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
